'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactFela = require('react-fela');

var Spacer = function Spacer(props) {
  return {
    minHeight: !props.horizontal && props.size,
    minWidth: props.horizontal && props.size,
    flex: '0 0 ' + props.size
  };
};

exports.default = (0, _reactFela.createComponent)(Spacer);
module.exports = exports['default'];